import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ShieldCheck } from "lucide-react";
import { kundenZiel } from "@/portal/startziel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WhatsAppBestaetigenPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({ phase: "pruefen", text: "" });
  const einmal = useRef("");
  useEffect(() => {
    const t = new window.URLSearchParams(location.search).get("t") || "";
    if (einmal.current === t) return;  // Token nur einmal einlösen (StrictMode/Re-Render)
    einmal.current = t;
    if (!/^[A-Za-z0-9_-]{20,80}$/.test(t)) { setState({ phase: "fehler", text: "Dieser Link ist ungültig. Du kannst die Bestätigung direkt im Kundenkonto starten (Tab „Heute“)." }); return; }
    axios.post(`${API}/whatsapp/verbindung/link/${t}`, {}, { withCredentials: true })
      .then((r) => { setState({ phase: "ok", text: r.data?.hinweis || "" }); window.setTimeout(() => navigate(kundenZiel(), { replace: true }), 1500); })
      .catch(async (e) => {
        if (e?.response?.status === 401) { navigate(`/kunden?next=${encodeURIComponent(location.pathname + location.search)}`, { replace: true }); return; }
        if (e?.response?.status === 410) {
          try {  // Link schon eingelöst, Bestätigungsweg aber offen → weiter ins Konto
            const st = (await axios.get(`${API}/whatsapp/verbindung`, { withCredentials: true })).data;
            if (["bestaetigung_offen", "code_angefordert", "versand_problem", "verbunden"].includes(st.status)) { setState({ phase: "ok", text: "" }); window.setTimeout(() => navigate(kundenZiel(), { replace: true }), 1200); return; }
          } catch (_) { /* Fehlertext unten */ }
        }
        setState({ phase: "fehler", text: e?.response?.data?.detail || "Das hat nicht geklappt." });
      });
  }, [location, navigate]);
  return (
    <main className="min-h-screen bg-[#F6F6F2] px-4 py-16" data-testid="wa-bestaetigen-page">
      <div className="mx-auto max-w-md rounded-2xl border border-[#BFE3C9] bg-white p-6 shadow-sm">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#1F5A3E] text-[#C6F56B]"><ShieldCheck size={20} /></span>
        <h1 className="mt-3 font-display text-2xl font-extrabold text-[#111]">Handynummer sicher bestätigen</h1>
        {state.phase === "pruefen" && <p className="mt-2 text-sm text-[#5C574F]" data-testid="wa-link-pruefen">Link wird geprüft … Der Link allein bestätigt nichts – die Bestätigung erfolgt gleich per Einmalcode in deinem Kundenkonto.</p>}
        {state.phase === "ok" && <p className="mt-2 text-sm text-[#1F5A3E]" data-testid="wa-link-ok">{state.text || "Link geprüft. Du wirst in dein Kundenkonto geleitet – dort „Bestätigungscode anfordern“, Code eintragen und Dienstnachrichten bestätigen."}</p>}
        {state.phase === "fehler" && <p className="mt-2 rounded-lg bg-[#FDE7E7] px-3 py-2 text-sm text-[#8A1F1F]" data-testid="wa-link-fehler">{state.text}</p>}
        <Link to={kundenZiel()} className="mt-5 inline-flex rounded-full bg-[#111] px-5 py-2.5 text-sm font-bold text-[#C6F56B]" data-testid="wa-link-zum-konto">Zum Kundenkonto</Link>
      </div>
    </main>
  );
}
